import React from 'react';
import styled from 'styled-components';
import { breakpointMap, BreakpointsOfTOrT, theme } from '../../theme';

export type DividerSize = 'sm' | 'md' | 'lg';

export type HrProps = { size: BreakpointsOfTOrT<DividerSize> };

export type DividerProps = Partial<HrProps>;

const Hr = styled.hr<HrProps>`
  height: 1px;
  background-color: ${theme.colors.neutrals.solidGrays[6]};
  border: none;
  margin: ${theme.spacings[6].rem} 0;

  ${({ size }) =>
    breakpointMap(size, (dividerSize) => {
      switch (dividerSize) {
        case 'lg':
          return `margin: ${theme.spacings[6].rem} 0;`;
        case 'md':
          return `margin: ${theme.spacings[5].rem} 0;`;
        case 'sm':
        default:
          return `margin: ${theme.spacings[2].rem} 0;`;
      }
    })};
`;

export const Divider: React.FC<DividerProps> = ({ size = 'lg' }) => (
  <Hr size={size} />
);
